namespace RioERP.Reports {
    export interface OrderShippingItemsReportRow {
        Id?: number;
        OrdershippingBooksId?: number;
        OrderId?: number;
        OrderNumber?: string;
        SourceType?: Web.Enums.SourceType;
        ProductName?: string;
        BookName?: string;
        Quantity?: number;
        PendriveType?: string;
        ShippingProviderName?: string;
        TrackingId?: string;
        TrackingUrl?: string;
        ProductId?: number;
        ProductBookid?: number;
        PenDriveTypeId?: number;
        ShippingProviderId?: number;
    }

    export namespace OrderShippingItemsReportRow {
        export const idProperty = 'Id';
        export const nameProperty = 'OrderNumber';
        export const localTextPrefix = 'Reports.OrderShippingItemsReport';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            Id = "Id",
            OrdershippingBooksId = "OrdershippingBooksId",
            OrderId = "OrderId",
            OrderNumber = "OrderNumber",
            SourceType = "SourceType",
            ProductName = "ProductName",
            BookName = "BookName",
            Quantity = "Quantity",
            PendriveType = "PendriveType",
            ShippingProviderName = "ShippingProviderName",
            TrackingId = "TrackingId",
            TrackingUrl = "TrackingUrl",
            ProductId = "ProductId",
            ProductBookid = "ProductBookid",
            PenDriveTypeId = "PenDriveTypeId",
            ShippingProviderId = "ShippingProviderId"
        }
    }
}
